import { Icon, Spinner2, Text } from 'components';
import { theme } from 'lib';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import WebsiteButton from './WebsiteButton';

const TextButton = styled.button`
  margin: ${(props) => props.marg || 0};
  cursor: pointer;
  display: flex;
  align-items: center;
  ${(props) => props.wid && `width: ${props.wid};`}
  ${(props) => props.col && `color: ${props.col};`}
`;

const AppButton = styled.button`
  width: ${(props) => props.wid || '100%'};
  height: ${(props) => (props.small ? '32px' : props.big ? '44px' : '40px')};
  margin: ${(props) => props.marg || 0};
  padding: ${(props) => props.pad || '0 12px'};
  background-color: #000;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  grid-column: ${(props) => 'span ' + props.gridColSpan};

  ${(props) =>
    props.bordered &&
    `
    height: ${props.small ? '30px' : props.big ? '42px' : '38px'};
    border: 2px solid #000;
    background-color: transparent;
  `};

  ${(props) =>
    props.reverse &&
    `
    border-color: #fff;
    background-color: transparent;
  `};

  ${(props) => props.bg && `background-color: ${props.bg};`};
  ${(props) => props.disabled && `background-color: ${theme.GREY_20.trim()};`};

  ${(props) =>
    !props.disabled &&
    `
    &:hover {
      opacity: 0.8;
    }

    &:active {
      opacity: 1;
      transform: scale(0.98);
    }

    transition: opacity 0.3s;
  `};
`;

const SocialContainer = styled.div`
  flex-direction: row;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PaypalImage = styled.img`
  position: absolute;
  left: 12px;
  height: 28px;
  width: 23px;
`;

const SocialImage = styled.img`
  position: absolute;
  left: 8px;
  height: 32px;
  width: 32px;
`;

const Button = (props) => {
  const { facebook, google, paypal, apple } = props,
    loadingButton = useSelector((state) => state?.appState?.loadingButton),
    isLoading = (loadingButton && loadingButton === props.action) || props.loading,
    { isMobile } = global;

  function getTextColor() {
    if (props.reverse) return '#fff';
    if (props.bordered) return '#000';
    return props.textColor || '#fff';
  }

  if (facebook || google || paypal || apple) {
    const socialName = paypal ? 'Paypal' : facebook ? 'Facebook' : google ? 'Google' : 'Apple';

    return (
      <AppButton onClick={() => null} {...props} bordered big marg={props.marg}>
        <SocialContainer>
          {paypal && (
            <PaypalImage resizeMode="contain" src={require(`assets/icons/PaypalSignup.png`)} />
          )}

          {facebook && (
            <SocialImage resizeMode="contain" src={require(`assets/icons/FacebookSignup.png`)} />
          )}

          {google && (
            <SocialImage resizeMode="contain" src={require(`assets/icons/GoogleSignup.png`)} />
          )}

          {apple && (
            <SocialImage resizeMode="contain" src={require(`assets/icons/AppleSignup.png`)} />
          )}

          <Text b1 bold>
            {props.text} with {socialName}
          </Text>
        </SocialContainer>
      </AppButton>
    );
  }

  if (props.website) return <WebsiteButton {...props} isLoading={isLoading} />;

  if (props.textButton) {
    return (
      <TextButton onClick={() => null} {...props}>
        {props.icon && (
          <Icon
            marg={isMobile ? '0 7.75px 0 0' : '0 11px 0 0'}
            type={props.icon}
            col={props.iconCol || theme.PRIMARY_BLACK}
            dimensions={isMobile ? 10.5 : 18}
          />
        )}

        <Text b2 bold col={props.textCol || theme.PRIMARY_BLACK}>
          {props.text}
        </Text>
      </TextButton>
    );
  }

  return (
    <AppButton
      onClick={() => null}
      {...props}
      isMobile={isMobile}
      disabled={isLoading || props.disabled}
    >
      {isLoading ? (
        <Spinner2 />
      ) : (
        <React.Fragment>
          {props.icon && (
            <Icon
              marg={props.text && (isMobile ? '0 7.75px 0 0' : '0 7px 0 0')}
              type={props.icon}
              col={getTextColor()}
              dimensions={props.iconSize || 14}
            />
          )}

          <Text
            bold
            b2
            center
            wid={!props.icon && '100%'}
            col={getTextColor()}
            className={props.className}
            {...props.textStyle}
          >
            {props.text}
          </Text>
        </React.Fragment>
      )}
    </AppButton>
  );
};

export default Button;
